import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

// Auth
import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";
import OnboardingSteps from "./components/auth/OnboardingSteps";
import ForgotPassword from "./components/auth/ForgotPassword";
import PasswordResetSuccess from "./components/auth/PasswordResetSuccess";
import NewPassword from "./components/auth/NewPassword";
import EmailVerification from "./components/auth/EmailVerification";
import WorkspaceReady from "./components/auth/WorkspaceReady";
import TeamMemberSignup from "./components/auth/TeamMemberSignup";
import AssetEmailVerify from "./components/dashboard/AssetEmailVerify";

// Layout
import Layout from "./components/sidebar/Layout";
import AuthLayout from "./components/layout/AuthLayout";

// Pages
import GoogleCallback from "./pages/GoogleCallback";
import Authorize from "./pages/Authorize";

// Guards / Context
import ProtectedRoute from "./components/ProtectedRoute";
import ProductGuard from "./components/ProductGuard";
import { UserProvider } from "./contexts/UserContext";

// ── Dark Web Monitoring pages ─────────────────────────────────
import DarkWebHome from "./components/dashboard/DarkWebHome";
import BreachDatabase from "./components/dashboard/BreachDatabase";
import BreachBreakdown from "./components/dashboard/BreachBreakdown";
import MonitoredEmails from "./components/dashboard/MonitoredEmails";
import DomainLookalike from "./components/dashboard/DomainLookalike";
import IncidentResponse from "./components/dashboard/IncidentResponse";
import MonitoredDomains from "./components/dashboard/MonitoredDomains";
import MonitoredIPs from "./components/dashboard/MonitoredIPs";

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* ───── Public routes ───── */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/onboarding" element={<OnboardingSteps />} />
          <Route path="/workspace-ready" element={<WorkspaceReady />} />
          <Route path="/email-verification" element={<EmailVerification />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-success" element={<PasswordResetSuccess />} />
          <Route path="/new-password" element={<NewPassword />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />
          <Route path="/invite/:token" element={<TeamMemberSignup />} />
          <Route path="/integrations/authorize" element={<Authorize />} />
          <Route path="/darkweb/verify-email" element={<AssetEmailVerify />} />
          {/* ───── Protected routes (Dark Web Monitor) ───── */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <ProductGuard
                  product="darkweb_monitor"
                  crossAppUrl={process.env.REACT_APP_RECORDING_STUDIO_URL}
                >
                  <Layout />
                </ProductGuard>
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="/overview" element={<DarkWebHome />} />
            <Route path="/darkweb/breaches" element={<BreachDatabase />} />
            <Route path="/darkweb/breakdown" element={<BreachBreakdown />} />
            <Route path="/darkweb/emails" element={<MonitoredEmails />} />
            {/* duplicate with assetType */}
            <Route path="/darkweb/lookalikes" element={<DomainLookalike />} />
            <Route path="/darkweb/domains" element={<MonitoredDomains />} />
            <Route path="/darkweb/ips" element={<MonitoredIPs />} />
            <Route path="/darkweb/incidents" element={<IncidentResponse />} />
          </Route>

          {/* ───── Fallback ───── */}
          <Route path="*" element={<Navigate to="overview" replace />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
